import { FormControl, Select, MenuItem, Typography, Card, Box } from '@mui/material';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { cardStyle } from './TransitionStyles';
import useNavigationDisabledMessage from './useNavigationDisabledMessage';

FormsDropdown.propTypes = {
  formName: PropTypes.string,
  isAddingFac: PropTypes.bool,
  subFormName: PropTypes.string,
};

export default function FormsDropdown({ formName, isAddingFac, subFormName = null }) {
  const navigate = useNavigate();
  const {
    data: { statusConfig, currentStatusByPortfolio, statusConfigSortedKeys },
  } = useSelector((state) => state.transitions);
  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('facilityId');
  const { id } = useParams();
  const [currentStatusSortOrder, setCurrentStatusSortOrder] = useState();

  useEffect(() => {
    setCurrentStatusSortOrder(
      Object.values(statusConfig)?.find((x) => x.id === currentStatusByPortfolio[id])?.sortOrder
    );
  }, [currentStatusByPortfolio]);

  const disabledMessage = useNavigationDisabledMessage(isAddingFac);

  const showFormSelect = useMemo(
    () => id !== undefined && statusConfigSortedKeys?.[0] !== currentStatusByPortfolio[id],
    [id, statusConfigSortedKeys, currentStatusByPortfolio]
  );

  return (
    <Card sx={{ ...cardStyle, p: 0, mb: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        {showFormSelect ? (
          <FormControl size="small">
            <Select
              displayEmpty
              defaultValue=""
              onChange={(e) => {
                navigate(e.target.value);
              }}
              renderValue={() => (
                <Typography align="center" variant="h6" color="info.main">
                  {formName}
                </Typography>
              )}
            >
              <MenuItem value="" disabled sx={{ fontWeight: 'bold' }}>
                {!!disabledMessage ? disabledMessage : 'Select page'}
              </MenuItem>
              {Object.values(statusConfig || {})
                ?.filter((x) => x.sortOrder <= currentStatusSortOrder)
                ?.map((status) => (
                  <MenuItem
                    key={status.id}
                    value={`/dashboard/transitions/${status.pageRouteName}/${id}?facilityId=${facilityId}`}
                    disabled={!!disabledMessage}
                  >
                    {status.formName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : (
          <Typography align="center" variant="h6" color="info.main" sx={{ p: '8.5px' }}>
            {formName}
          </Typography>
        )}
      </Box>
      {subFormName && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography align="center" variant="h6" color="info.main">
            {subFormName}
          </Typography>
        </Box>
      )}
    </Card>
  );
}
